import React, { useEffect, useState, useRef } from 'react';

/**
 * HeroProgressBar
 * Animated progress bar that fills over `duration` ms,
 * resets on every `key` change (slide change).
 */
const HeroProgressBar = ({ duration = 5000, slideKey }) => {
  const [progress, setProgress] = useState(0);
  const rafRef = useRef(null);
  const startTimeRef = useRef(null);

  useEffect(() => {
    // Reset on new slide
    setProgress(0);
    startTimeRef.current = null;

    const animate = (timestamp) => {
      if (!startTimeRef.current) startTimeRef.current = timestamp;
      const elapsed = timestamp - startTimeRef.current;
      const pct = Math.min((elapsed / duration) * 100, 100);
      setProgress(pct);

      if (pct < 100) {
        rafRef.current = requestAnimationFrame(animate);
      }
    };

    rafRef.current = requestAnimationFrame(animate);

    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slideKey, duration]);

  return (
    <div
      className="w-full h-1 bg-white/20 rounded-full overflow-hidden"
      role="progressbar"
      aria-valuenow={Math.round(progress)}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        className="h-full rounded-full bg-gradient-to-r from-[#800000] to-rose-400 transition-none"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

export default HeroProgressBar;
